// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"178":"11761ff2","229":"8e4db35e","263":"11761ff2","479":"11761ff2","779":"11761ff2","842":"11761ff2","915":"11761ff2"}[chunkId] + ".chunk.css";
};